{
  "orderBook": {
    "title": "Order book",
    "bid": "Bid",
    "ask": "Ask",
    "bidSell": "Bid (Sell)",
    "askBuy": "Ask (Buy)"
  }
}
